import { AfterViewInit, Component, ElementRef, inject, OnDestroy, ChangeDetectionStrategy } from '@angular/core';

import { MobileScanningService } from '../mobile-scanning.service';
import { toObservable } from '@angular/core/rxjs-interop';
import { Subscription } from 'rxjs';

@Component({
    selector: 'pcg-strich-scanner'
    , templateUrl: './scanner.component.html'
    , styleUrls: ['./scanner.component.scss']
    , standalone: true
    , changeDetection: ChangeDetectionStrategy.Eager
    , host: { '(window:resize)': 'onResize()' }
})
export class ScannerComponent implements AfterViewInit, OnDestroy {

    private scannerService = inject(MobileScanningService);
    private hostElementRef = inject(ElementRef);

    useAudio$ = toObservable(this.scannerService.useAudio);
    useAudioSubscription?: Subscription;

    ngAfterViewInit() { 
        this.newBarcodeReader();
        this.bindUseAudio();
    }

    ngOnDestroy() { 
        this.useAudioSubscription?.unsubscribe();
        return this.scannerService.releaseBarcodeReader(); 
    }

    newBarcodeReader() {
        try { return this.scannerService.newBarcodeReader(this.hostElementRef); } 
        catch (ex) { console.error(ex); }
    }

    // When the useAudio signal changes, reinitialize the barcode reader with the new configuration.
    //
    // Future To Do: convert entire configuration object to a signal listen to changes
    // and reinitialize the barcode reader when any of the configuration properties change.
    // Tried this briefly, but the configuration signal wouldn't emit changes when updated...
    bindUseAudio() {
        this.useAudioSubscription = this.useAudio$.subscribe((useAudio) => {
            if (this.scannerService.barcodeReader) { 
                this.scannerService.releaseBarcodeReader()
                    .then(() => this.newBarcodeReader())
                    .catch(err => console.error('Error releasing barcode reader:', err));
            }
        });
    }

    // Reinitialize the barcode reader when the window is resized.
    // This is needed when switching between portrait and landscape modes on mobile devices
    onResize() {
        if (this.scannerService.barcodeReader) {
            this.scannerService.releaseBarcodeReader().then(() => {
                this.newBarcodeReader();
            });
        } else {
            this.newBarcodeReader();
        }
    }
}
